import { get } from './index'

/**
 * 获取成果列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.limit - 每页数量
 * @param {string} params.category - 成果分类
 * @param {string} params.type - 成果类型
 * @param {string} params.sort - 排序字段
 * @param {string} params.order - 排序方向
 * @returns {Promise} API响应
 */
export const getAchievements = (params = {}) => get('/result/list', params)

/**
 * 获取成果详情
 * @param {string} id - 成果ID
 * @returns {Promise} API响应
 */
export const getAchievementById = (id, locale = '') => {
  const localeParam = locale ? `&locale=${locale}` : ''
  return get(`/result/getResultById?resultId=${id}${localeParam}`)
}

/**
 * 获取成果详情（包含扩展信息）
 * @param {string} id - 成果ID  
 * @returns {Promise} API响应
 */
export const getAchievementDetail = (id) => get(`/achievements/${id}/detail`)

/**
 * 获取成果分类列表
 * @returns {Promise} API响应
 */
export const getAchievementCategories = () => get('/achievements/categories')

/**
 * 按分类获取成果列表
 * @param {string} category - 分类名称
 * @param {Object} params - 其他查询参数
 * @returns {Promise} API响应
 */
export const getAchievementsByCategory = (category, params = {}) => 
  get('/achievements', { ...params, category })

/**
 * 搜索成果
 * @param {Object} params - 搜索参数
 * @param {string} params.q - 搜索关键词
 * @param {string} params.category - 成果分类
 * @param {string} params.type - 成果类型
 * @returns {Promise} API响应
 */
export const searchAchievements = (params = {}) => get('/achievements/search', params)

/**
 * 获取推荐成果
 * @param {string} achievementId - 当前成果ID
 * @param {number} limit - 推荐数量
 * @returns {Promise} API响应
 */
export const getRecommendedAchievements = (achievementId, limit = 3) =>
  get(`/achievements/${achievementId}/recommended`, { limit })

export default {
  getAchievements,
  getAchievementById,
  getAchievementDetail,
  getAchievementCategories,
  getAchievementsByCategory,
  searchAchievements,
  getRecommendedAchievements
} 